import React, { Component } from "react";
//import { Bar, Line } from 'react-chartjs-2';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,

  //  PopoverHeader,
} from "reactstrap";

import Accordion from "react-bootstrap/Accordion";

import { Pie, Bar } from "react-chartjs-2";
import ScrollHint from "scroll-hint";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaInfoCircle, FaSearch } from "react-icons/fa";

import GLOBALS from "../../../Globals";
import axios from "axios";
import { saveAs } from "file-saver";
import ReactPlayer from "react-player";
import "bootstrap/dist/css/bootstrap.min.css";

class Workbook extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      // videoUrl: false,
      // chapters: {
      //   am: [
      //     10, 30, 50, 70, 90, 110, 130, 150, 170, 190, 210, 230, 250, 270, 290,
      //     310, 330, 350, 370, 390,
      //   ],
      //   pm: [
      //     20, 40, 60, 80, 100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300,
      //     320, 340, 360, 380, 400,
      //   ],
      // },
    };

    // this.retrieveData();
  }

  // componentDidUpdate(prevProps, prevState) {
  //   //this.setState({data: undefined})
  //   if (prevProps.match.params.nth !== this.props.match.params.nth) {
  //     this.retrieveData();
  //   }

  //   new ScrollHint(".table-responsive", {
  //     i18n: {
  //       scrollable: "右にスクロールできます",
  //     },
  //   });
  // }
  // const [currentPosition, setCurrentPosition] = useState(0);

  render() {
    return (
      <div className="animated fadeIn sheet workbook">
        <Row>
          <Col>
            <Card className="judge3">
              <CardHeader>
                第{this.props.match.params.nth}回 理解度確認テスト問題・正答
              </CardHeader>
              <CardBody>
                <p>
                  なすもし第{this.props.match.params.nth}
                  回での出題に近い国試の過去問で構成される確認テストです。下記の科目名から問題・正答を閲覧・ダウンロードできます。きちんと復習ができているか確認しましょう。
                </p>

                <Row>
                  <Col xs="12" md="12" xl="12">
                    <p>
                      <strong>科目ごとにテストを行う場合はこちら</strong>
                    </p>
                  </Col>
                </Row>

                <Row>
                  <Col xs="12" md="6" xl="6">
                    <ul>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/01.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          必修問題
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/01a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/02.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          人体の構造と機能
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/02a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/03.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          疾病の成り立ちと回復の促進
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/03a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/04.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          健康支援と社会保障制度
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/04a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/05.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          基礎看護学
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/05a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>

                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/06.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          在宅看護論/地域・在宅看護論
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/06a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                    </ul>
                  </Col>

                  <Col xs="12" md="6" xl="6">
                    <ul>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/07.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          成人看護学
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/07a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/08.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          老年看護学
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/08a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>{" "}
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/09.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          小児看護学
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/09a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/10.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          母性看護学
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/10a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/11.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          精神看護学
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/11a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/12.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          看護の統合と実践
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>{" "}
                        &nbsp;&nbsp;
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/12a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          正答
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      {/* <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/00.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          全問題
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/0a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          解答用紙
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li> */}
                    </ul>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" md="6" xl="6">
                    <p>
                      <strong>一度に全科目のテストを行う場合はこちら</strong>
                    </p>

                    <ul>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/00.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          全問題 (正答含む)
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" md="12" xl="12">
                    <p>
                      <strong>解答用紙のダウンロードはこちら</strong>
                    </p>
                    <ul>
                      <li>
                        <a
                          href={`https://moshi-problem.s3.ap-northeast-1.amazonaws.com/nasumoshi/${GLOBALS.YEAR}/check/${this.props.match.params.nth}/0a.pdf`}
                          target="_blank"
                          className="link_to_pdf "
                        >
                          解答用紙
                          <img
                            className="icon_pdf"
                            src="/assets/img/icon_pdf.svg"
                            alt=""
                          />
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>

                <Row>
                  <Col xs="12" md="12" xl="12">
                    <p>
                      <strong>アドバイス</strong>
                    </p>
                    <p>
                      問題用紙の自信度の欄に、どの程度自信をもって選択肢を選んだかを、〇△×の3段階で記入してみましょう。{" "}
                      <br />
                      〇：自信あり　△：あいまい　×：自信なし
                      <br />
                      自信があったのに間違えた問題、あいまい・自信がなかったのに正解した問題を意識して復習すると、効率よく学習を進めることができます。
                    </p>
                    <p>
                      ※問題用紙の下部のページ数は正答ページを含めて表記しているため、１ページ少ない表記となっています。
                    </p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Workbook;
